import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";

const CreateCountry = (props) => {
    const [StoreName, setStoreName] = useState('');
    const [StoreCode, setStoreCode] = useState('');
    const [response, fetchData] = UseFetchData();
    const [responseGetData, fetchGetData] = UseFetchData();

    const validationSchema = Yup.object({
        StoreCode: Yup.string().required('Required!'),
        StoreName: Yup.string().required('Required!'),
    });

    const onSubmit = values => {
        debugger;
        var bodyFormData = new FormData();
        bodyFormData.append("Type", 'Store');
        bodyFormData.append("PKID", props.PKID);
        bodyFormData.append("Value1", values.StoreCode);
        bodyFormData.append("Value2", values.StoreName);
        fetchData("Primary/Save", bodyFormData);
    };

    const getByIDData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("Type", 'Store');
        bodyFormData.append("PKID", props.PKID);
        fetchGetData("Primary/GetByID", bodyFormData);
    }

    useEffect(() => {
        if (response.Response === true) {
            props.setOpen(false);
            props.PopulateData();
            alert('Saved Succesfully.')
        }
        else if (response.Response === false) {
            alert('Save Failed.')
        }
    }, [response])

    useEffect(() => {
        debugger;
        if (responseGetData.length > 0) {
            setStoreCode(responseGetData[0].StoreCode);
            setStoreName(responseGetData[0].StoreName);
        }
    }, [responseGetData])

    useEffect(() => {
        if (props.PKID !== '') {
            getByIDData();
        }
    }, [])

    return (
        <div>
            <Formik initialValues={{ StoreName: StoreName, StoreCode: StoreCode }}
                validationSchema={validationSchema} onSubmit={onSubmit} enableReinitialize>
                {formik => {
                    return <Form>
                        <Grid spacing={2} container>
                            <Grid item xs={12}>
                                <Grid item xs={12}>
                                    <BiztranControlsFormik
                                        control='input'
                                        type='text'
                                        label='Store Code'
                                        name='StoreCode'
                                        onChange={(e) => setStoreCode(e.target.value)}
                                    />
                                </Grid>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='Store Name'
                                    name='StoreName'
                                    onChange={(e) => setStoreName(e.target.value)}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <div style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>
                                        <BiztranControls.Button
                                            text="SAVE"
                                            type="submit"
                                            startIcon={<SaveIcon />}
                                        />
                                        <BiztranControls.Button
                                            text="CLOSE"
                                            startIcon={<CloseIcon />}
                                            onClick={() => { props.setOpen(false); }}
                                        />
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Form>
                }}
            </Formik>
        </div>
    );
}

export default CreateCountry;
